export class QnoCountReqModel {
    chapter: number;
    subAbilityId: number;
    marks: number

    constructor(chapter: number, subAbilityId: number, marks: number) {
        this.chapter = chapter;
        this.subAbilityId = subAbilityId;
        this.marks = marks
    }
}